export default __webpack_public_path__ + "static/media/thumbnail2.3b379dd9.png";